module.exports = __webpack_public_path__ + "ed859e25fc67a7975f77771ff8e32b79.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg49.jpeg
// module id = 60
// module chunks = 0